var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.button)?_c('router-link',{attrs:{"to":_vm.$attrs.to},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var navigate = ref.navigate;
var isActive = ref.isActive;
return [_c('a',_vm._b({staticClass:"header-button no-outline text-regular",class:{
			'header-button--is-dark': _vm.isDark,
			'header-button--is-selected': isActive,
			'header-button--is-hovered': _vm.isHovered,
		},attrs:{"href":href},on:{"click":navigate}},'a',_vm.$attrs,false),[_vm._t("default")],2)]}}],null,true)}):(_vm.button)?_c(_vm.tag,_vm._b({tag:"component",staticClass:"header-button no-outline text-regular",class:{
		'header-button--is-dark': _vm.isDark,
		'header-button--is-selected': _vm.isSelected,
		'header-button--is-hovered': _vm.isHovered,
	},on:{"click":function($event){return _vm.$emit('click')}}},'component',_vm.$attrs,false),[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }